//本地储存封装
export const getItem = name => {
    const data = window.localStorage.getItem(name)
        // data 不是 json 格式字符串
    try {
        //尝试把 data 转为 javaScr ipt对象
        return JSON.parse(data)
    } catch (err) {
        // data 不是 json 格式字符串，直接原样返回
        return data
    }
}

export const setItem = (name, value) => {
    if (typeof value === 'object') {
        value = JSON.stringify(value)
    }
    window.localStorage.setItem(name, value)
}

export const removeItem = name => {
    window.localStorage.removeItem(name)
}

/*
* 获取URL里面的参数
* */
export const getUrlParam = (name) => {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
    const r = window.location.search.substr(1).match(reg) // 匹配目标参数
    if (r != null) return decodeURI(r[2])
    return null // 返回参数值
}